<template>
  <admin-layout>
    <template slot="content">
      <header-for-list-component sectionName="Requerimentos" :items="applications" :totalItems="totalItems"
        :totalPages="totalPages" :itemsPerPage="itemsPerPage" :pageNumber.sync="pageNumber"
        @loadPage="loadPage($event)" />

      <v-layout align-center class="mb-3">
        <v-flex xs4>
          <v-text-field v-model="search" solo label="Buscar Requerimento" prepend-inner-icon="mdi-magnify" hide-details
            :loading="loadingSearch" @input="typing()">
            <template v-slot:progress>
              <v-progress-linear v-if="loadingSearch" color="accent" indeterminate height="3"></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex>
          <v-btn style="float: right; font-size: 12px" class="btn-primary" href="/#/admin/requerimentos/lista">
            <v-icon small medium>mdi-arrow-left</v-icon> Voltar à tela inicial
          </v-btn>
        </v-flex>


      </v-layout>
      <v-layout column>
        <v-data-table :headers="headers" :items="applications" hide-actions class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.application_type.acronym }} - {{ props.item.person.name }}</td>
            <td class="text-xs-center">{{ props.item.folder_number || '--' }}</td>
            <td class="text-xs-center">{{ formatCpfCnpj(props.item.person.cpf_cnpj) }}</td>
            <td class="text-xs-center">
              <v-list-tile-action-text :class="[paymentSlipBadge(props.item.payment_slips[0]), 'badge']">
                {{ statusPaymentSlip(props.item.payment_slips[0]) }}
              </v-list-tile-action-text>
            </td>
            <td class="text-xs-center">
              <v-list-tile-action-text :class="`badge ${props.item.status}`">
                {{ statusTitle(props.item.status) }}
              </v-list-tile-action-text>
            </td>
            <td>
              <v-layout row>
                <v-btn icon @click="showApplication(props.item.id)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout';
import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
import ApplicationService from '@/services/applications/configurations/ApplicationService';
import formatCpfCnpj from '@/utils/formatCpfCnpj';

export default {
  name: 'List',
  components: {
    AdminLayout,
    HeaderForListComponent,
  },
  mounted() {
    this.loadPage(1);
  },
  data() {
    return {
      formatCpfCnpj,
      search: '',
      applications: [],
      application: null,
      loadingSearch: false,
      interval: null,
      totalItems: 0,
      totalPages: 0,
      itemsPerPage: 20,
      pageNumber: 1,
      headers: [
        { text: 'ID', value: 'id', sortable: false, align: 'center', width: '5%' },
        { text: 'Nome', value: 'name', sortable: false, align: 'center', width: '30%' },
        { text: 'Processo', value: 'process', sortable: false, align: 'center', width: '10%' },
        { text: 'CPF - CNPJ', value: 'cpf_cnpj', sortable: false, align: 'center', width: '15%' },
        { text: 'Boleto', value: 'payment_slip', sortable: false, align: 'center', width: '15%' },
        { text: 'Status', value: 'status', sortable: false, align: 'center', width: '15%' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center', width: '10%' }],
      mode: 'create',
      applicationType: null,
    };
  },
  methods: {
    showApplication(id) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push({ name: 'AdminShowApplication', params: { id } });
    },
    loadPage(pageNumber) {
      this.pageNumber = pageNumber || this.pageNumber;
      if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
      ApplicationService
        .all({
          limit: this.itemsPerPage,
          page: this.pageNumber,
          q: this.search,
        })
        .then(({ data }) => {
          this.applications = data.applications || [];
          this.totalItems = data.total;
          this.totalPages = data.total_pages;
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
          this.loadingSearch = false;
        });
    },
    typing() {
      clearInterval(this.interval)
      this.interval = setTimeout(() => {
        this.loadingSearch = true;
        this.pageNumber = 1;
        this.loadPage();
      }, 500);
    },
    statusTitle(status) {
      const statusTitle = {
        'waiting_to_be_sent': 'A ENVIAR',
        'waiting_for_review': 'EM ANÁLISE',
        'pending': 'PENDENTE',
        'done': 'APROVADO',
        'intimated': 'INTIMAÇÃO'
      };
      return statusTitle[status];
    },
    statusPaymentSlip(paymentSlip) {
      if (!paymentSlip) {
        return 'Boleto não disponível'
      }
      return {
        true: "Pago",
        false: "Em aberto"
      }[paymentSlip.payment_status]
    },
    paymentSlipBadge(paymentSlip) {
      if (!paymentSlip) return 'waiting_to_be_sent';
      return paymentSlip.payment_status ? 'done' : 'pending';
    }
  },
};
</script>

<style scoped lang="scss">
.badge {
  color: #fff;

  &.waiting_to_be_sent {
    background: #616161;
  }

  &.waiting_for_review {
    background: #ffc107;
  }

  &.pending,
  &.intimated {
    background: #f44336;
  }

  &.done {
    background: #4caf50;
  }

}
</style>
